/**
 * The Benny daily message cap, as both surfaces present it: whether it still
 * bites, and the reset moment in the viewer's own clock. The server sends
 * one sentence and an ISO `resetsAt`; the client adds the local time.
 */

import { format, isToday, isTomorrow } from 'date-fns'

/**
 * Is the cap still active? A live check, never a memo: the moment can pass
 * while the tab sits open, and the hosts clear the value on their own timers.
 */
export function isDailyLimitActive(resetsAt?: string | null): boolean {
  return !!resetsAt && new Date(resetsAt).getTime() > Date.now()
}

/**
 * The reset moment in the viewer's own clock: "5:00 PM", "1:00 AM tomorrow",
 * or with the day spelled out when it's further off (clock skew, odd windows).
 */
export function formatResetTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return 'tomorrow'
  const time = format(date, 'h:mm a')
  if (isToday(date)) return time
  if (isTomorrow(date)) return `${time} tomorrow`
  return `${time} on ${format(date, 'EEE, MMM d')}`
}

/** The notice sentence both composers show while the cap is active. */
export function dailyLimitNotice(resetsAt: string): string {
  return `You've used today's Benny messages. They refresh at ${formatResetTime(resetsAt)}.`
}
